import * as React from 'react';

import { enumUnit, Unit } from '@rematter/frontend-lib-api-client';
import {
  humanReadableShortPricingUnit,
  NumberField,
  cn,
} from '@rematter/ui-web';

export interface WeightFieldCellProps {
  value: number;
  onChange?: (value: number) => void;
  disabled?: boolean;
  unit?: Unit;
  className?: string;
  onFocus?: () => void;
  onBlur?: () => void;
  prefix?: React.ReactNode;
  suffix?: string;
  errorMessage?: string;
  isInvalid?: boolean;
}

export const WeightFieldCell: React.FC<WeightFieldCellProps> = ({
  value,
  onChange,
  disabled = false,
  unit,
  className,
  onFocus,
  onBlur,
  prefix,
  suffix,
  errorMessage,
  isInvalid,
}) => (
  <NumberField
    value={value}
    onChange={onChange}
    prefix={prefix}
    suffix={suffix ?? humanReadableShortPricingUnit(unit ?? enumUnit.Pounds)}
    isDisabled={disabled}
    formatOptions={{
      minimumFractionDigits: 0,
      maximumFractionDigits: 2,
    }}
    onFocus={onFocus}
    onBlur={onBlur}
    showSteppers={false}
    errorMessage={errorMessage}
    isInvalid={isInvalid}
    className={cn('@WeightFieldCell', className)}
  />
);
